<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="img/brand/white.png" alt="logo" title="Home">
            </router-link>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <li class="nav-item">
                    <router-link to="/" class="nav-link nav-link-icon">Home</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/taxes" class="nav-link nav-link-icon" v-html="$t('taxes')"></router-link>
                </li>
                <!-- <li class="nav-item">
                    <router-link to="/inactive" class="nav-link nav-link-icon">Inactive</router-link>
                </li> -->
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://github.com/cmoine"
                       target="_blank" rel="noopener" data-toggle="tooltip" title="My account on Github">
                        <i class="fa fa-github"></i>
                        <span class="nav-link-inner--text d-lg-none">Github</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="www.linkedin.com/in/cmoine"
                       target="_blank" rel="noopener" data-toggle="tooltip" title="My account on LinkedIn">
                        <i class="fa fa-linkedin-square"></i>
                        <span class="nav-link-inner--text d-lg-none">Github</span>
                    </a>
                </li>
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="#" class="btn btn-neutral btn-icon" @click="nextLang">
                        <span class="btn-inner--icon">
                            <i class="fa fa-language mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text" v-html="$t('switch')"></span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import CONSTANTS from '@/constants'

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  computed: {
      nextLangLabel() {
          return CONSTANTS.LANGUAGES[(this.$store.state.currentLanguage+1)%CONSTANTS.LANGUAGES.length]
      }
  },
  methods: {
      nextLang() {
          this.$store.commit('nextLang')
          this.$nextTick(() => {
              this.refreshTitle()
          });
      },
      refreshTitle() {
          var title=window.document.title
          title=title.replace(this.$t('title', 'fr'), "")
          title=title.replace(this.$t('title', 'en'), "")
          var array=title.split('');
          array.splice(title.indexOf(' ') + 1, 0, this.$t('title'))
          title=array.join('')
          window.document.title=title
      }
  },
  created() {
      this.refreshTitle()
  }
};
</script>
<style>
</style>

<i18n>
{
  "en": {
    "switch": "Fran&ccedil;ais",
    "taxes": "Property Taxes (France only)",
    "title": "Christophe Moine's incredible website"
  },
  "fr": {
    "switch": "English",
    "taxes": "Taxes fonci&egrave;res",
    "title": "L'incroyable site web de Christophe Moine"
  }
}
</i18n>
